import {Component, Inject} from '@angular/core';
import {DialogRef} from '../../dialog/dialog-ref';
import {DIALOG_DATA} from 'src/app/services/dialog.service';
import {IEmployeeNotification} from 'src/app/interfaces/approval-notifications.interfaces';

@Component({
  selector: 'app-cancel-modal',
  templateUrl: './cancel-modal.component.html',
  styleUrls: ['./cancel-modal.component.scss'],
})
export class CancelModalComponent {
  constructor(
    private dialogRef: DialogRef,
    @Inject(DIALOG_DATA)
    public data: {notification: IEmployeeNotification}
  ) {}

  notCancel() {
    this.dialogRef.close();
  }

  cancel() {
    this.dialogRef.close('canceled');
  }
}
